export function deferredGroups(rows, decisions) {
    const groups = new Map();
    rows.forEach(row => {
        const key = row.source_subject || row.decision_key;
        if (!groups.has(key)) groups.set(key, []);
        groups.get(key).push(row);
    });
    return Array.from(groups.values()).filter(group => group.every(row => row.can_defer && row.status === 'conflict'
        && !(decisions[row.decision_key] || {}).action));
}

export function deferRows(rows, decisions) {
    const result = Object.assign({}, decisions);
    rows.forEach(row => {
        result[row.decision_key] = Object.assign({}, result[row.decision_key], {action: 'defer', employee_id: null,
            activate_employee: false, reject_candidate_ids: [], confirmed_manual_termination_event_id: null,
            accept_hiring_form_from_1c: false});
    });
    return result;
}
